module.exports = __webpack_public_path__ + "img/PTTGC.4e613692.jpg";